// extracted by mini-css-extract-plugin
export default {"CRN":"AddNewCRN_CRN__kO9IL"};